import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=5fbc127f&"
import script from "./ResetForm.vue?vue&type=script&lang=js&"
export * from "./ResetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports